exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barestho-forgot-password-link {\n    display: block;\n    text-align: right;\n    color: var(--main-white) !important;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.barestho-forgot-password-link:hover {\n    opacity: 0.5;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/Authentication/LoginForm.css
// module id = 2235
// module chunks = 29